/**
 * 全局对象管理单例类（静态类）
 * 基于 ES6 Map 实现，用于集中存储和访问应用内的全局共享对象/资源
 * 核心功能：全局对象的存、取、判断存在、删除，无冗余逻辑，极简实用
 */
export class GlobalManager{
    // 静态私有 Map（全局唯一，外部无法直接访问）
    static #globalMap = new Map();

    // 1. 获取全局对象（key 不存在返回 undefined，可自行加默认值）
    static get(key){
        return this.#globalMap.get(key);
    }

    // 2. 存储全局对象（Map 原生 set 方法，覆盖已有 key）
    static set(key, obj){
        this.#globalMap.set(key, obj);
    }

    // （可选）按需添加常用辅助方法（不想要可以删掉）
    // 判断是否存在某个 key
    static has(key) {
        return this.#globalMap.has(key);
    }

    // 删除某个全局对象（释放资源用）
    static delete(key) {
        this.#globalMap.delete(key);
    }
}